import Snippet from "../../../../components/Snippet/Snippet"
import { column } from '../../../../assets/code-snippets/column/snip'

const Column = () => {
    return <div className="container fluid my-1" id="column">

        <div className="container fluid">
            <p className="text xl"><a className="link" href="#poke-column">&#128279;</a> Column view in grid
            system </p>
            <p className="text md">
                <code>column</code> class forces the children
            elements to be displayed in column view, HTML has set this by default, I mean column
            view,
            everything displays in column as you read a newspaper, but sometimes we might need
            to force the children of some parent element to be displayed in column view, and this is
            why
            <code>column</code> class was created, if is needed I'll know is there :)
        </p>
        </div>

        <div className="container md py-5">
            <Snippet code={column} language='html' />
        </div>

        <div className="container border border-dark px-2 py-5">
            <div className="column">
                <div className="col III p-2 border-light">col</div>
                <div className="col III p-2 border-light">col</div>
                <div className="col III p-2 border-light">col</div>
            </div>
        </div>

    </div>
}
export default Column